export const PHOTO = "photo";
export const PHOTO_URL = "photo-url";
export const VIDEO = "video";
